module.exports = __webpack_public_path__ + "static/media/sleeping.426d717f.jpg";